/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PassScheduleSelectionType {
  NONE = 'none',
  WEEKLY_SLOTS = 'weekly_slots',
  DATED_SESSIONS = 'dated_sessions',
}
